import httpCommon from "@/axios/chat/http-common";
import qs from "qs";

const TagService = {
    /**
     * API lấy tất cả dữ liệu thẻ
     * */
    getAll: async (page, limit, search) => {
        return httpCommon.get("system/tag", {
            params: {
                search: search,
                page: page,
                limit: limit,
            }
        });
    },

    /**
     * API tạo mới thẻ hệ thống
     * */
    create: async (data) => {
        return httpCommon.post("system/tag", data);
    },

    /**
     * API chỉnh sửa thẻ
     * */
    update: async (data) => {
        return httpCommon.put("system/tag", data);
    },

    /**
     * API cập nhật sử dụng thẻ
     * */
    updateActive: async (data) => {
        return httpCommon.put("system/tag/active", data);
    },

    delete: async (ids) => {
        return await httpCommon.delete("system/tag", {
            params: {
                ids: ids // mảng
            },
            paramsSerializer: params => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
        });
    }
};

export default TagService;
